export const API_BASE_URL =
  process.env.NEXT_PUBLIC_ENVIRONMENT == 'PRODUCTION'
    ? 'https://api.ultrahuman.com'
    : 'https://www.staging.ultrahuman.com';

export const WEBCMS_API_BASE_URL =
  process.env.NEXT_PUBLIC_ENVIRONMENT == 'PRODUCTION'
    ? 'https://web-cms-backend.ultrahuman.com'
    : 'http://localhost:3001';
